import { AdminCard, AdminHeader, Field } from "./AdminShell";

export default function Settings() {
  return (
    <div>
      <AdminHeader title="Store Settings" description="Single-store configuration for branding, language, currency, SEO, theme, and live chat links." />
      <div className="grid gap-6 xl:grid-cols-2">
        <AdminCard title="General">
          <div className="space-y-4">
            <Field label="Site Name"><input className="input" defaultValue="SellerSupply Shop" /></Field>
            <Field label="Logo URL"><input className="input" defaultValue="/logo.svg" /></Field>
            <Field label="Support Email"><input className="input" placeholder="support@example.com" /></Field>
          </div>
        </AdminCard>
        <AdminCard title="Language & Currency">
          <div className="grid gap-4 md:grid-cols-2">
            <Field label="Default Language"><select className="input" defaultValue="en"><option value="en">English</option><option value="zh">中文</option><option value="es">Español</option><option value="ru">Русский</option><option value="tg">Тоҷикӣ</option></select></Field>
            <Field label="Default Currency"><select className="input" defaultValue="USD"><option>USD</option><option>EUR</option><option>CNY</option><option>RUB</option><option>TJS</option><option>USDT</option></select></Field>
          </div>
        </AdminCard>
        <AdminCard title="SEO">
          <div className="space-y-4">
            <Field label="Homepage SEO Title"><input className="input" defaultValue="SellerSupply Shop - Global Online Store" /></Field>
            <Field label="Homepage SEO Description"><textarea className="input min-h-24 rounded-[24px]" defaultValue="Shop practical products with multilingual support, manual payment options, and a simple checkout experience." /></Field>
          </div>
        </AdminCard>
        <AdminCard title="Theme & Support">
          <div className="grid gap-4 md:grid-cols-2">
            <Field label="Theme Color"><input className="input" defaultValue="#F7F3EC" /></Field>
            <Field label="Button Color"><input className="input" defaultValue="#0F172A" /></Field>
            <Field label="WhatsApp Link"><input className="input" /></Field>
            <Field label="Telegram Link"><input className="input" /></Field>
          </div>
        </AdminCard>
      </div>
    </div>
  );
}
